

<ion-split-pane contentId="main" when="(min-width: 1px)">
  <ion-menu contentId="main" *ngIf="isLogged">
    <ion-content>
      <ion-list [ngClass]="{'safe-area-inset-top': isCapacitor}">
        <ion-menu-toggle auto-hide="false">
          <ion-item lines="none" (click)="toggleMenu()">
            <ion-icon name="menu-sharp"></ion-icon>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
          <ion-item lines="none" (click)="goBack()">
            <ion-icon name="mic-outline"></ion-icon>
            <span>Enregistrer</span>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
          <ion-item lines="none" (click)="goBack(true)">
            <ion-icon name="download-outline"></ion-icon>
            <span>Uploader</span>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
          <ion-item lines="none" (click)="goBack()">
            <ion-icon name="file-tray-full-outline"></ion-icon>
            <span>Mes enregistrements</span>
          </ion-item>
        </ion-menu-toggle>
        <div class="profile">
          <ion-menu-toggle auto-hide="false" *ngIf="currentUser && currentUser.is_app_ghost">
            <ion-item lines="none" (click)="register()">
              <!-- <ion-icon name="person-circle-outline"></ion-icon> -->
              <ion-icon name="person-add-outline"></ion-icon>
              <span>Créer un compte</span>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false">
            <ion-item lines="none" (click)="deleteAccount()">
              <!-- <ion-icon name="person-circle-outline"></ion-icon> -->
              <ion-icon name="close-circle-outline"></ion-icon>
              <span>Supprimer mon compte</span>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false">
            <ion-item lines="none" (click)="logout()">
              <!-- <ion-icon name="person-circle-outline"></ion-icon> -->
              <ion-icon name="log-out-outline"></ion-icon>
              <span>Se déconnecter</span>
            </ion-item>
          </ion-menu-toggle>
        </div>

        <!-- <ion-menu-toggle auto-hide="false" class="profile">
          <ion-item lines="none" (click)="logout()">
            <ion-icon name="log-out-outline"></ion-icon>
            <span>Se déconnecter</span>
          </ion-item>
        </ion-menu-toggle> -->
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-split-pane>
